import React, { forwardRef } from "react";

import styles from "../Styles/ui/Badge.module.css";

function Badge({ className, variant = "default", ...props }) {
  const variantClass = styles[`badge${variant.charAt(0).toUpperCase() + variant.slice(1)}`];
  return (
    <div
      className={`${styles.badge} ${variantClass} ${className}`}
      {...props}
    />
  );
}

export { Badge };